import { useCallback, useMemo } from 'react';

import { splice } from '@lyearn/core/utils/immutable';
import { useTranslation } from '@lyearn/i18n';
import { Box, Input, Stack, Typography } from '@lyearn/ui';

import { DEFAULT_RATING_LABELS } from '../../../../utils/adapters';
import { RatingLabelsProps } from './types';
import { getRatingLevels } from './utils';

const RatingLabels: React.FC<RatingLabelsProps> = (props) => {
  const { value = DEFAULT_RATING_LABELS, disabled, onChange, error } = props;
  const { t } = useTranslation();

  const levels = useMemo(() => {
    return getRatingLevels(t).map(({ label }, index) => {
      return {
        label: `${t('UserSurvey:QuestionSettings.Level', { count: index + 1 })} (${label})`,
      };
    });
  }, [t]);

  const onChangeText = useCallback(
    (index: number, text: string) => {
      const newLevels = splice(value, index, 1, { labelName: text, rating: index + 1 });

      onChange(newLevels);
    },
    [onChange, value],
  );

  return (
    <Stack className="mt-4" direction="col">
      <Box className="rounded-8 bg-bg-secondary p-12">
        <Typography color="text-text-paragraph" variant="body-long-02">
          {t('UserSurvey:QuestionSettings.LabelsDescription')}
        </Typography>
      </Box>
      <Stack className="mt-16" direction="col" gapY={8}>
        {levels.map((level, index) => {
          return (
            <Input
              key={index}
              characterLimit={24}
              disabled={disabled}
              error={error && !value[index].labelName}
              placeholder={level.label}
              value={value[index].labelName}
              onChangeText={(text) => onChangeText(index, text)}
            />
          );
        })}
      </Stack>
      {error ? (
        <Typography className="mt-8 ms-8" color="text-text-error" variant="body-short-03">
          {t('UserSurvey:QuestionSettings.EmptyLabels')}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default RatingLabels;
